import React from 'react';

const KioskForms = ({ forms }) => (
  <div className="attendance-individual__kiosk">
    {forms
      .filter(f => !!f)
      .map((f, index) => (
        <div key={`kiosk_form_${index}`} className="attendance-individual__kiosk-item">
          <div>
            <b>Q:</b> {f.question}
          </div>
          {f.answers &&
            f.answers.map((a, aIndex) => (
              <div key={`kiosk_form_answer_${index}_${aIndex}`}>
                <b>A:</b> {a}
              </div>
            ))}
          {f.note && (
            <div>
              <b>Note:</b> {f.note}
            </div>
          )}
        </div>
      ))}
  </div>
);

export default KioskForms;
